module.exports = __webpack_public_path__ + "866bbc0e7b23d30fe9823889de7ee435.svg";